import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@teem/app/core/services/user.service';
import { LoaderService } from '@teem/services/loader.service';
import { AuthService } from '@teem/app/core/services/auth.service';
import { environment } from '@teem/environments/environment';
import { messages as i18n } from '@teem/constants/messages';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
	selector: 'app-tap-increase-consent-modal',
	templateUrl: './tap-increase-consent-modal.component.html'
})
export class TapIncreaseConsentModalComponent implements OnInit {
	@Input() userInfo;
	submitted: boolean = false;
	addTapForm: FormGroup;

	constructor(
		private fb: FormBuilder,
		public activeModal: NgbActiveModal,
		private userService: UserService,
		private loaderService: LoaderService,
		private authService: AuthService,
		private el: ElementRef
	) {
		this.createAddTapFormGroup();
	}

	ngOnInit(): void {
		//
	}

	createAddTapFormGroup() {
		this.addTapForm = this.fb.group({
			is_agreement_accept:  [false, Validators.required],
		});
	}

	get f() {
		return this.addTapForm.controls;
	}

	onSubmit() {
		this.submitted = true;
		if (this.addTapForm.valid) {
			let fd = this.addTapForm.value;
			if (fd.is_agreement_accept == 2) {
				Swal.fire({
					title: i18n.are_you_sure,
					text: i18n.tap.you_want_deactivated_account,
					icon: 'info',
					showCloseButton: true,
					showCancelButton: true,
					focusConfirm: false,
					confirmButtonText: i18n.yes,
					cancelButtonText: i18n.no_cancel_it
				}).then((result: any) => {
					if (result.value) {
						this.submitFrom();
					} else {
						return false;
					}
				});
			} else {
				this.submitFrom();
			}
			this.submitted = false;
		}
	}

	submitFrom() {
		let fd = this.addTapForm.value;
		console.log('fd')
		console.log(fd)
		if (fd.is_agreement_accept) {
			this.loaderService.startLoading();
			this.userService.updateTapConsent(fd).subscribe(
				(res: any) => {
					this.loaderService.stopLoading();
					this.addTapForm.reset();
					this.activeModal.close(res);
					if (fd.is_agreement_accept == 2) {
						Swal.fire(i18n.done, i18n.tap.tap_agreement_rejected, 'success');	
					} else {
						Swal.fire(i18n.done, i18n.success.tap_agreement_accepted_successfully, 'success');
					}
				},
				(err) => {
					this.loaderService.stopLoading();
					if (err.status === 422) {
						if (err.error && err.error.errors && Object.keys(err.error.errors).length) {
							let validationErrors = err.error.errors;
							Object.keys(validationErrors).forEach((prop) => {
								this.addTapForm.get(prop)?.setErrors({
									serverError: validationErrors[prop]
								})
							})
						}
					}
					Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
				}
			)
		} else {
			Swal.fire(i18n.alert.error, 'Please check checkbox', 'error');
		}
	}
}
